import Vue from 'vue'
import wizardVue from '../../../components/operations/ai_call/create/wizard.vue'

export default {
  wizard: function () {
    document.addEventListener('DOMContentLoaded', () => {
      new Vue({
        el: '#ai_call_create_wizard',
        render: h => h(wizardVue)
      })
    })
  }
}
